import { Injectable, inject } from '@angular/core';
import { FetchResult } from '@apollo/client';
import { Observable, of, throwError } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { AsyncValidationError } from '@cm/ui-modules';

@Injectable({
  providedIn: 'root',
})
export class ResponseService {
  private readonly translateService = inject(TranslateService);

  responseToDataOrError<T>({ errors, data }: FetchResult<T>): Observable<T> {
    if (errors && errors.length > 0) {
      const firstError = errors[0];
      const error: AsyncValidationError = {
        fieldName:
          firstError.message === 'already-exists' && !firstError.extensions?.fieldPath
            ? 'email'
            : (firstError.extensions?.fieldPath as string) || 'unknown',
        message: this.translateService.instant(`responseErrorMsg.${firstError.message}`),
      };
      return throwError(() => error);
    } else {
      if (data == null) {
        return throwError(() => new Error('No data received'));
      }
      return of(data);
    }
  }
}
